// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--Af9hD";
export var reactShare__ShareButton = "styles-module--react-share__ShareButton--URi1G";
export var success__toast = "styles-module--success__toast--8KtFS";